/**
 * Extracted from sections/ns-experts-slider.liquid (inline <script> at line 273).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-experts-slider.liquid:273) ---
(function () {
  function expertSliderInit () {

   let contentContainerEl = document.querySelector('.expert-slider')

   let {
      itemsPerRowDesktop,
    } = contentContainerEl.dataset

    function waitForSwiper(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkInterval);
            callback();
          }
        }, 100);
      }
    }

    let testSwiper;
    waitForSwiper(() => {
      testSwiper = new Swiper('.expert-slider__wrapper', {
      slidesPerView: 1.125,
      spaceBetween: 10,

      speed: 600,

      breakpoints: {
        320: {
          slidesPerView: 1.15,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1.15,
          spaceBetween: 15
        },
        640: {
          slidesPerView: 1.15,
          spaceBetween: 15
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: itemsPerRowDesktop ? itemsPerRowDesktop : 4,
          spaceBetween: 30
        }
      },

      autoHeight: true,

      navigation: {
        nextEl: '.expert-slider__swiper-button-next',
        prevEl: '.expert-slider__swiper-button-prev',
      },

      pagination: {
        el: ".expert-slider__swiper-pagination",
        clickable: true
      },

      })
    });
  }

  expertSliderInit()

  if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        expertSliderInit()
      });
  }
})();
